<template>
  <div class="bq-footer" ref="footer" :class="{ mobile: isMobile }">
    <div class="bq-footer-wrap">
      <div class="bq-footer-links">
        <bq-col
          class="bq-link-item"
          v-for="item in bqColList"
          :key="item.title"
          :class="{ flex: item.flex }"
          :title="item.title"
          :list="item.list"
        />
      </div>

      <div class="bq-footer-copyright" v-if="!isMobile">
        <p>
          Copyright © 2019-2022 浙江扁鹊健康科技有限公司 版权所有
        </p>
        <span>浙ICP备</span><a :href="forRecord">19005522号-2</a>
      </div>

      <div class="bq-footer-copyright" v-else>
        <img class="bq-logo" :src="logo.murl" :alt="logo.title" />
        <p>Copyright © 2022</p>
        <p>浙江扁鹊健康科技有限公司</p>
        <p>All Rights Reserved</p>
        <a :href="forRecord">浙ICP备19005522号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
import BqCol from './Col';

import { logo } from '../Header/header.js';
// import { isWirelessDevice } from '@/utils/utils';
import { website_v3 } from './website_v3Footer';
import { project_env, forRecord } from '@/defaultSettings';

export default {
  name: 'BQFooter',

  components: {
    BqCol,
  },

  data() {
    return {
      isMobile: false,
      logo,
      footerData: {
        website_v3,
      },
      forRecord,
    };
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  computed: {
    bqColList() {
      return this.footerData[project_env];
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
